import React from "react";
import ControlDetailsPanel from "./ControlDetailsPanel";
import BatteryLevelChart from "./BatteryLevelChart";
import PhotoVoltaicSystem from "./PhotoVoltaicSystem";
import BatteryTemperatureChart from "./BatteryTemperatureChart";
import EnergyTable from "./EnergyTable";
import { IControlPhotoVoltaic } from "../types";
import PVEnergyChart from "./PVEnergyChart";

interface IControlDetailsPhotoVoltaicProps {
  control: IControlPhotoVoltaic;
}

const ControlDetailsPhotoVoltaic = (
  props: IControlDetailsPhotoVoltaicProps
) => {
  const { control } = props;
  return (
    <ControlDetailsPanel
      mode={control.is_enabled ? "on" : "disabled"}
      title={control.name}
    >
      <PhotoVoltaicSystem control={control} />
      <PVEnergyChart control={control} width={300} height={80} />
      <BatteryLevelChart control={control} width={300} height={80} />
      <BatteryTemperatureChart control={control} width={300} height={80} />
      <EnergyTable control={control} />
    </ControlDetailsPanel>
  );
};

export default ControlDetailsPhotoVoltaic;
